module.exports = __webpack_public_path__ + "img/ayuda-verificacion-1.4a8bfdf2.png";